export default function formatErrorLabel(label, errorMessage) {
    return `${label} · ${errorMessage}`;
}
